export const scrollToSection = (section: HTMLElement) => {
  window.scrollTo({
    top: section?.offsetTop,
    behavior: "smooth"
  });
};

export const focusSectionHeader = (section: HTMLElement) => {
  const sectionHeader = section.querySelector("[role='button']") as HTMLElement;

  sectionHeader && sectionHeader.focus({ preventScroll: true });
};
